import React from 'react'
import { URL_S3 } from '../../../../config/BaseUrl'

const RecentPhoto = (prop) => {
    const {recentPhoto} = prop
    return (
        <>
            <div className="photos pt-2">
                <div className="row">

                <div className="col-12">
                    <div className="analytic-photos">
                    <div className="gallery-body mt-3">
                        <div className="row">
                        <div className="col-12">
                            <h5 className="text-secondary">Recent Photo</h5>
                        </div>
                        <div className="col-12">
                            <div className="photos-list">
                                <div className="row gallery-horizontal">

                                    {recentPhoto.map((item) => {
                                        return (
                                            <div key={item.id} className="gallery-item col-md-3 mb-4 text-center">
                                                <div className="image">
                                                    <img src={`${URL_S3}event_gallery/photo/${item.event_photo}`} alt="placeholder" className="hello img-fluid" />
                                                </div>
                                            </div>
                                        )
                                    })}

                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>

                </div>
            </div>
            
        </>
    )
}

export default RecentPhoto
